angular.module('CarsSaraBo').controller('CarLoaderController', ['$scope', '$routeParams','$q','$translate','Upload', 'NotificationService',
                                       function($scope, $routeParams,$q,$translate,Upload, notificationService) {
	
	$scope.initialize = function() {
		$scope.file = [];

	}
	
	$scope.uploadFile=function(){
		$scope.showProgressBar();
	    $scope.upload([$scope.file]);
	}
	
	  $scope.upload = function (files) {
		  if(files[0] && files[0].length > 0) {
	        console.log(files[0])
			  Upload.upload({
	            url: '../rest/loader/upload',
	            file: files[0]
	        }).progress(function (evt) {
	           
	        }).success(function (data, status, headers, config) {
	        	$scope.hideProgressBar();
	        	notificationService.notifyInfoByCode("fleet.batchUpload.SUCCESS_SAVE");
	    		$scope.file = [];
	        }).error(function (data, status, headers, config) {
	        	$scope.hideProgressBar();
	        	notificationService.notifyErrorByCode("fleet.batchUpload.ERROR_SAVE");
	        });
		  }
	  }
	  
	$scope.initialize();
}]); 


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/carLoader_controller.js
// module id = 897
// module chunks = 3